import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['common'] = {
    calls:            'Қоңыраулар',
    close:            'Жабу',
    comment:          'Пікір',
    forms:            'Өтінімдер',
    nextPage:         'Келесі бет',
    pagination:       'Беттер',
    playbackPosition: 'Ойнату позициясы',
    previousPage:     'Алдыңғы бет',
    send:             'Жіберу',
};

export default kk;
